import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthProviderEnum} from "../enum/auth-provider-enum";
import {
	TenantVerificationTransmissionService
} from "../../raintree/transmission/tenant-verification-transmisssion/tenant-verification-transmission.service";
import {AuthTransmissionService} from "../../raintree/transmission/auth-transmission/auth-transmission.service";
import {RequestMapperService} from "../../request-mapper.service";
import {RaintreeResponse} from "../../raintree/interface/raintree-response";
import {TenantResponse} from "../../raintree/interface/tenant-response/tenant-response";
import {ToastMessageService} from "../../services/toast-message.service";
import {RegistrationData} from "../interface/registration-data";
import {BloomsightService} from "../../bloomsight.service";

@Component({
  selector: 'fb-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent {

	@Output()
	public authProvider: EventEmitter<AuthProviderEnum> = new EventEmitter<AuthProviderEnum>();
	public passwordType: 'password' | 'text' = 'password';
	public confirmPasswordType: 'password' | 'text' = 'password';
	public firstNameControl: FormControl = new FormControl('', [
		Validators.required,
		Validators.minLength(3)
	]);
	public lastNameControl: FormControl = new FormControl('', [
		Validators.required,
		Validators.minLength(3)
	]);

	@Input()
	public emailFormControl: FormControl = new FormControl('', [
		Validators.required,
		Validators.email
	]);

	public passwordFormControl: FormControl = new FormControl('', [
		Validators.required,
		Validators.minLength(8),
		Validators.maxLength(38)
	]);

	public confirmPasswordFormControl: FormControl = new FormControl('', [
		Validators.required,
		Validators.minLength(8),
		Validators.maxLength(38)
	]);

	public registrationFormGroup: FormGroup = new FormGroup({
		firstName: this.firstNameControl,
		lastName: this.lastNameControl,
		password: this.passwordFormControl,
		confirmPassword: this.confirmPasswordFormControl
	});

	public isSuccessfull: boolean = false;

	constructor(
		private _authTransmission: AuthTransmissionService,
		private _tenantVerification: TenantVerificationTransmissionService,
		private _toast: ToastMessageService,
		private _bloomsight: BloomsightService
	) {
	}

	public basicRegister(): void {
		if (
			this.registrationFormGroup.valid &&
			(this.passwordFormControl.value === this.confirmPasswordFormControl.value) &&
			this.emailFormControl.valid
		) {
			const tenantData = this._mapRegisterData(
				this.firstNameControl.value + ' ' + this.lastNameControl.value,
				this.emailFormControl.value.trim().toLowerCase(),
				this.passwordFormControl.value,
				false,
				AuthProviderEnum.BASIC
			)
			this._registerTenant(tenantData);
		}
		else {
			this.firstNameControl.markAsDirty();
			this.lastNameControl.markAsDirty();
			this.emailFormControl.markAsDirty();
			this.passwordFormControl.markAsDirty();
			this._toast.error(
				'Fields are empty.',
				'Please fill up all the required fields.'
			)
		}
	}

	private _mapRegisterData(
		name: string,
		email: string,
		password: string,
		emailVerified: boolean,
		provider: AuthProviderEnum
	): RegistrationData {
		return {
			tenant: {
				name: name,
				email: email,
				password: password,
				emailVerified: emailVerified,
				provider: provider,
				gender: ''
			}
		}
	}

	private _registerTenant(
		data: RegistrationData
	): void {
		this._authTransmission.register(
			RequestMapperService.REGISTER_EMAIL,
			data,
			() => {},
			() => {},
			(response: RaintreeResponse | TenantResponse) => {
				this._toast.success(
					'You have been successfully registered!',
					'Thank You for creating an account. Please check your email inbox / SPAM to verify',
					'top-right',
					6000
				);
				this.isSuccessfull = true;
				this._bloomsight.trackDataEvent(
					'671a29d522fb296d61f458a4',
					{email: this.emailFormControl.value.trim().toLowerCase()},
					'New Registration'
					);
				this.registrationFormGroup.reset();
			},
			(error: string) => {
				this._toast.error(
					error,
					error
				);
				this.isSuccessfull = false;
			},
			() => {
			}
		)
	}

	public resendEmail(): void {
		this._tenantVerification.sendEmail(
			RequestMapperService.SEND_EMAIL,
			this.emailFormControl.value,
			() => { },
			() => { },
			(response: RaintreeResponse | TenantResponse) => {
				// console.log(response)
				this._toast.success('Email send successfully.', 'Please check your email and verify.');
			},
			(error: string) => {
				// console.log(error)
			},
			() => {
			}

		)
	}


	protected readonly AuthProviderEnum = AuthProviderEnum;
}
